import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import EditModal from '../componentes/EditModal';
import DeleteConfirm from '../componentes/DeleteConfirm';
import { Plus } from 'lucide-react';

const UsuariosPanel = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const fetchUsuarios = async () => {
    try {
      setLoading(true);
      const res = await api.get('/usuarios');
      setUsuarios(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchUsuarios(); }, []);

  const handleEdit = (user) => {
    setSelected({ ...user });
    setShowEdit(true);
  };

  const handleCreate = () => {
    setSelected(null);
    setShowEdit(true);
  };

  const handleDelete = (id) => {
    setSelected(usuarios.find(u => u.id === id));
    setShowDelete(true);
  };

  const handleSave = async (formData) => {
    // No enviar password vacío
    const payload = { ...formData };
    if (!payload.password) delete payload.password;
    
    if (selected) {
      await api.put(`/usuarios/${selected.id}`, payload);
    } else {
      // Crear usuario requiere password
      if (!payload.password) {
        throw new Error('La contraseña es obligatoria');
      }
      await api.post('/usuarios', payload);
    }
    setShowEdit(false);
    fetchUsuarios();
  };

  const confirmDelete = async () => {
    await api.delete(`/usuarios/${selected.id}`);
    setShowDelete(false);
    fetchUsuarios();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'email', label: 'Email' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'apellido', label: 'Apellido' },
    { key: 'fecha_nacimiento', label: 'Fecha Nac.' },
    { key: 'root', label: 'Admin', render: (val) => val == 1 ? 'Sí' : 'No' },
    { key: 'recibir_emails', label: 'Emails', render: (val) => val == 1 ? 'Sí' : 'No' },
  ];

  const data = usuarios.map(u => ({
    ...u,
    root: u.root == 1 ? 'Sí' : 'No',
    recibir_emails: u.recibir_emails == 1 ? 'Sí' : 'No',
  }));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Usuarios</h1>
        <button className="sp-btn sp-btn--primary" onClick={handleCreate}>
          <Plus size={18} /> Nuevo
        </button>
      </div>

      <DataTable
        columns={columns}
        data={data}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showEdit && (
        <EditModal
          title={selected ? 'Editar usuario' : 'Crear usuario'}
          fields={[
            { name: 'email', label: 'Email', type: 'email' },
            { name: 'nombre', label: 'Nombre' },
            { name: 'apellido', label: 'Apellido' },
            { name: 'fecha_nacimiento', label: 'Fecha de nacimiento', type: 'date' },
            { name: 'password', label: selected ? 'Nueva contraseña (dejar vacío para no cambiar)' : 'Contraseña', type: 'password' },
            { name: 'root', label: 'Es administrador', type: 'checkbox' },
            { name: 'recibir_emails', label: 'Recibe emails', type: 'checkbox' },
          ]}
          initialValues={selected || {}}
          onSave={handleSave}
          onCancel={() => setShowEdit(false)}
        />
      )}

      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar al usuario ${selected.email}?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default UsuariosPanel;